import React, { useState } from "react";
import "./updateMontant.scss";

import { Close, SchoolOutlined } from "@mui/icons-material";

import "react-phone-input-2/lib/style.css";
import { CircularProgress, IconButton } from "@mui/material";
import { PaiementType, requestType } from "../../types/GlobalType";
import Loader from "../loader/Loader.tsx";
import { accountService } from "../../_services/accountServices";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { API_PAIEMENT } from "../../apiCaller/paiement.Caller";
import ErrorBar from "../errorComp/ErrorBar.tsx";
import { catchErrorApiCall } from "../../_services/apiUtils.js";
import axios from "axios";
import { URL_BACKEND_APP } from "../../App.constants.js";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  data: PaiementType | undefined;
}
const UpdateMontant = (props: Props) => {
  const [montant, setMontant] = useState<any>(props.data?.montant);

  // console.log(montant);

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const navigate = useNavigate();

  const handleUpdate = async () => {
    console.log(montant);

    // Check if the montant is valid
    function isPositiveNumber(input) {
      const positiveNumberPattern = /^(0|[1-9]\d*)(\.\d+)?$/;
      return positiveNumberPattern.test(input);
    }

    if (!isPositiveNumber(montant)) {
      setState({
        isLoading: false,
        errorMessage: "Veuillez enter un montant entier et positif",
      });

      return setTimeout(() => {
        setState((prev) => ({ ...prev, errorMessage: null }));
      }, 4000);
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    const url = `${URL_BACKEND_APP}/paiement/update.php?id=${props.data?.paiement_id}`;
    let data = {
      montant: montant,
      // terminal_id: "1",
    };
    const headers = {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    };

    try {
      console.log(data);

      await axios.put(url, data, { headers });
      console.log(await axios.put(url, data, { headers }));

      props.setOpen(false);
      toast.success("Mise à jour effectuée avec succès", { duration: 3000 });
      navigate("/paiement");
    } catch (error) {
      console.log(error);
      catchErrorApiCall(error);
    } finally {
      setState({ isLoading: false, errorMessage: null, successMessage: null });
    }
  };
  return (
    <>
      {/* <Loader isLoading={state.isLoading} /> */}
      <div className="updateMontant">
        <div className="dialog_update">
          <div className="headerUpdate">
            <div className="titleUpdate">
              <div className="left_">
                <SchoolOutlined className="ico" />
                <span>Modification - Paiement</span>
              </div>
              <IconButton>
                <Close className="ico" onClick={() => props.setOpen(false)} />
              </IconButton>
            </div>
          </div>

          <div className="body_update">
            {state.errorMessage && <ErrorBar title={state.errorMessage} />}
            <div className="item">
              <label>Montant</label>
              <input
                placeholder="Montant"
                type="number"
                onChange={(e) => setMontant(e.target.value)}
                value={montant}
              />
            </div>
          </div>
          <div className="btn">
            <button onClick={() => props.setOpen(false)}>Annuler</button>
            {!state.isLoading && (
              <button onClick={handleUpdate}>Modifier</button>
            )}
            {state.isLoading && (
              <button>
                <CircularProgress disableShrink size={15} />
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateMontant;
